import React, { useMemo } from "react";
import MyDropdown from "../../../../Common/my-dropdown/my-dropdown-new.component";
import ThreeDotsIcon from "../../../../icons/three-dots.icon";
import styles from "./index.module.scss";
import { UserStatus } from "../members.mock-data";

interface ActionsMenuProps {
  onResetPassword?: () => void;
  onResetMFA?: () => void;
  onActivateMFA?: () => void;
  onDisableAccount?: () => void;
  onEnableAccount?: () => void;
  onResendVerificationLink?: () => void;
  onDelete?: () => void;
  isDistributorView?: boolean;
  userStatus?: string;
}

type MenuItem = {
  label: string;
  onClick?: () => void;
  className?: string;
};

const ActionsMenu = ({
  onResetPassword,
  onResetMFA,
  onActivateMFA,
  onDisableAccount,
  onEnableAccount,
  onResendVerificationLink,
  onDelete,
  isDistributorView = false,
  userStatus,
}: ActionsMenuProps) => {
  const menuOptions: MenuItem[][] = useMemo(() => {
    if (isDistributorView && userStatus === UserStatus.Disabled) {
      return [
        [
          { label: "Enable Account", onClick: onEnableAccount, className: "f-grey f-14 line-height-22" },
          { label: "Delete", onClick: onDelete, className: "f-red f-14 line-height-22" },
        ],
      ];
    }
    
    if (isDistributorView && userStatus === UserStatus.Pending) {
      return [
        [
          { label: "Disable Account", onClick: onDisableAccount, className: "f-grey f-14 line-height-22" },
          { label: "Delete", onClick: onDelete, className: "f-red f-14 line-height-22" },
        ],
      ];
    }
    
    if (isDistributorView) {
      return [
        [
          { label: "Reset Password", onClick: onResetPassword, className: "f-grey f-14 line-height-22" },
        ],
        [
          { label: "Activate MFA", onClick: onActivateMFA, className: "f-grey f-14 line-height-22" },
        ],
        [
          { label: "Disable Account", onClick: onDisableAccount, className: "f-grey f-14 line-height-22" },
          { label: "Delete", onClick: onDelete, className: "f-red f-14 line-height-22" },
        ],
      ];
    }
    
    return [
      [
        { label: "Reset Password", onClick: onResetPassword, className: "f-grey f-14 line-height-22" },
        !isDistributorView && { label: "Reset MFA", onClick: onResetMFA, className: "f-grey f-14 line-height-22" },
      ],
      [
        { label: "Activate MFA", onClick: onActivateMFA, className: "f-grey f-14 line-height-22" },
      ],
      [
        { label: "Disable Account", onClick: onDisableAccount, className: "f-grey f-14 line-height-22" },
        { label: "Enable Account", onClick: onEnableAccount, className: "f-grey f-14 line-height-22" },
        { label: "Resend Verification Link", onClick: onResendVerificationLink, className: "f-grey f-14 line-height-22" },
        { label: "Delete", onClick: onDelete, className: "f-red f-14 line-height-22" },
      ],
    ];
  }, [isDistributorView, userStatus, onResetPassword, onResetMFA, onActivateMFA, onDisableAccount, onEnableAccount, onResendVerificationLink, onDelete]);

  return (
    <MyDropdown>
      <MyDropdown.Toggle hideArrow className={styles.actionsButton}>
        <div className={styles.actionsButtonInner}>
          <ThreeDotsIcon />
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu 
        key={`${isDistributorView ? 'distributor' : 'default'}-${userStatus}`}
        className="no-wrap" 
        popperConfig={{ strategy: "fixed" }} 
        renderOnMount
      >
        {menuOptions.map((section, sectionIndex) => (
          <React.Fragment key={`section-${sectionIndex}`}>
            {sectionIndex > 0 && <div className="divider" />}
            {section.map((item) => (
              <MyDropdown.Item key={item.label} onClick={item.onClick} className={item.className}>
                {item.label}
              </MyDropdown.Item>
            ))}
          </React.Fragment>
        ))}
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default ActionsMenu;

